import { FaRing, FaHeart, FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaRing />, // Wedding ring icon
    title: 'Weddings Planned',
    count: '500',
  },
  {
    id: 2,
    icon: <FaHeart />, // Heart icon
    title: 'Happy Couples',
    count: '2000',
  },
  {
    id: 3,
    icon: <FaCalendarAlt />, // Calendar icon
    title: 'Years in Business',
    count: '15',
  },
  {
    id: 4,
    icon: <FaMapMarkerAlt />, // Map marker icon
    title: 'Locations Served',
    count: '50',
  },
];

export default counter;